import { render, staticRenderFns } from "./RouletteSetting.vue?vue&type=template&id=d4e93464&"
import script from "./RouletteSetting.vue?vue&type=script&lang=js&"
export * from "./RouletteSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports